import styled from '@emotion/styled';

export const Container = styled.main`
	display: flex;
	flex-direction: column;
	/* gap: 8rem; */
	max-width: 135rem;
	width: 100%;
	margin: 0 auto;
	margin-top: calc(${(props) => props.theme.heights.header} + 8rem);
	margin-bottom: 8rem;
	@media screen and (max-width: 1180px) {
		margin-top: calc(${(props) => props.theme.heights.headerMobile} + 8rem);
		padding: 0 2rem;
	}
	@media screen and (max-width: 900px) {
		margin-top: calc(${(props) => props.theme.heights.headerMobile} + 8rem);
		padding: 0rem;
		gap: 0rem;
	}
`;
export const Header = styled.div`
	display: flex;
	flex-direction: column;
	/* gap: 4.8rem; */
`;

export const HeaderTab = styled.div`
	padding-bottom: 6rem;
	@media screen and (max-width: 900px) {
		padding-bottom: 0rem;
	}
`;

export const HeaderContentTitle = styled.pre`
	font-size: ${(props) => props.theme.fontSize.size4xl};
	font-weight: ${(props) => props.theme.fontWeight.weightBold};
	line-height: 130%;
	letter-spacing: -0.6px;
	color: #212529;
`;
export const HeaderContentBox = styled.div`
	display: flex;
	height: 38rem;
	border: 1px solid #dee2e6;
	@media screen and (max-width: 900px) {
		flex-direction: column;
		height: auto;
		border: none;
		border-top: 1px solid #dee2e6;
	}
`;

export const HeaderContent = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	gap: 3.2rem;
	padding: 3.2rem;
`;
export const HeaderSubContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
`;
export const HeaderSubContentItem = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	line-height: 100%;
	letter-spacing: -0.6px;
	.title {
		display: flex;
		align-items: center;
		gap: 0.8rem;
		font-weight: ${(props) => props.theme.fontWeight.weightRegular};
		color: #495057;
	}
	.content {
		font-weight: ${(props) => props.theme.fontWeight.weightBold};
		color: #212529;
		line-height: 120%;
	}
`;
export const ImgBox = styled.div<{ bgImg: string }>`
	background-image: linear-gradient(0deg, rgba(0, 21, 52, 0.6) 0%, rgba(0, 21, 52, 0.6) 100%), url(${(props) => props.bgImg});
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	background-clip: content-box;
	background-origin: content-box;
	max-width: 88rem;
	width: 100%;
	position: relative;
	@media screen and (max-width: 900px) {
		max-width: 100%;
		height: 36rem;
	}
	.title_box {
		display: flex;
		flex-direction: column;
		gap: 1.2rem;
		position: absolute;
		top: 50%;
		left: 4rem;
		transform: translateY(-50%);
		@media screen and (max-width: 900px) {
			right: 4rem;
		}
		.title {
			color: #fff;
			font-size: 4rem;
			font-weight: 700;
			line-height: 120%;
			letter-spacing: -0.6px;
			@media screen and (max-width: 900px) {
				font-size: 3.2rem;
			}
		}
		.sub_title {
			color: #fff;
			font-size: 1.8rem;
			font-weight: 400;
			line-height: 120%;
			letter-spacing: -0.6px;
		}
	}
	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
`;
export const Title = styled.h2`
	font-size: ${(props) => props.theme.fontSize.size4xl};
	font-weight: ${(props) => props.theme.fontWeight.weightBold};
	line-height: 130%;
	letter-spacing: -0.6px;
	color: #212529;
	text-align: center;
	padding-bottom: 4rem;
`;

export const ConferenceBoardBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8rem;
	max-width: 84.4rem;
	width: 100%;
	margin: 0 auto;
`;

export const ContentBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
`;
export const ContentTitle = styled.p`
	color: #212529;
	font-size: ${(props) => props.theme.fontSize.size4xl};
	font-weight: ${(props) => props.theme.fontWeight.weightBold};
	line-height: 130%;
	letter-spacing: -0.6px;
`;

export const EmptyContent = styled.div`
	height: 113.4rem;
	width: 100%;
	background-color: red;
`;

export const BorderBox = styled.div`
	padding: 0.8rem 1.2rem;
	color: #495057;
	background-color: #f1f3f5;
	width: fit-content;
	border-radius: 999.9rem;
`;
export const PointFont = styled.span`
	color: #47a3f3;
`;
export const ScheduleBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2.4rem;
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightBold};
	line-height: 130%;
	letter-spacing: -0.6px;
	.danger {
		color: ${(props) => props.theme.colors.red600};
		font-size: ${(props) => props.theme.fontSize.sizeMd};
		font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	}
`;
export const ScheduleContent = styled.div`
	display: flex;
	gap: 0.8rem;
	align-items: center;
`;

export const GridBox = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 3.2rem;
`;

export const GridContentBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	.content_box {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 0.4rem;
		color: #000;
		.title {
			font-size: ${(props) => props.theme.fontSize.sizeMd};
			font-weight: ${(props) => props.theme.fontWeight.weightBold};
		}
		.content {
			font-size: ${(props) => props.theme.fontSize.sizeSm};
			font-weight: ${(props) => props.theme.fontWeight.weightRegular};
		}
	}
`;

export const GridImgBox = styled.div`
	display: flex;
	width: 100%;
	height: 8.8rem;
	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
`;
